import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/shared/services/product.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Product, optionGroup } from 'src/app/shared/models/product';
import * as _ from "lodash";
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-topping-group-settings',
  templateUrl: './topping-group-settings.component.html',
  styleUrls: ['./topping-group-settings.component.scss']
})
export class ToppingGroupSettingsComponent implements OnInit {
  toppingGroup: any;
  toppings: any;
  choosenToppingGroup: optionGroup = null;
  choosenToppingGroupForm: FormGroup;
  constructor(private producService: ProductService, private formBuilder: FormBuilder) { }
  ngOnInit() {
    this.producService.getToppingGroup()
      .snapshotChanges().subscribe(
        (product) => {
          // this.spinnerService.hide();
          let productList = [];
          product.forEach((element:any) => {
            const y = element.payload.toJSON();
            y['$key'] = element.key;
            productList.push(y as Product);
            if (!_.isNil(this.choosenToppingGroup) && element.key === this.choosenToppingGroup.$key) {
              this.selectGroup(y);
            }
          });
          this.toppingGroup = productList;
        }
      );
    this.producService.getToppings().valueChanges().pipe(take(1)).subscribe(toppings => {
      this.toppings = toppings;
    });
  }

  selectGroup(group: optionGroup) {
    this.choosenToppingGroup = group;
    this.choosenToppingGroupForm = this.formBuilder.group(group);
    this.onChanges();
  }

  onChanges(): void {
    this.choosenToppingGroupForm.valueChanges.subscribe(group => {
      this.producService.updateToppingGroup(group)
    });
  }

  addTopping(topping) {
    this.producService.addToppingToGroup(topping, this.choosenToppingGroup.$key)
  }

  deleteTopping(topping) {
    this.producService.deleteToppingToGroup(topping, this.choosenToppingGroup.$key)
  }
}
